//solo lo usaremos aqui
import {DetPeticionCorredoresComponent} from "./det-peticion-corredores.component";
import {share} from "rxjs";
import {HojasCallCenterComponent} from "../../hojas-call-center.component";

export class DetallePetCorredor {
  tipo: string = "";
  id: number = 0;
  fechaPet: string = "";
  titular: string = "";
  telefono: string = "";
  agente: string = "";
  nomAgente: string = "";
  subdelega: string = "";
  nsubdelega: string = "";
  email: string = "";
  taller: string = "";
  observaciones: string = "";
  estado: string = "";
  matricula: string = "";
  serRealizar: string = "";
  nomCliente: string = "";
  telServ: string = "";
  cia: string = "";
  campana: string = "";
  fecha: string = "";

  constructor() { }

 
public convertirDetalle(res: any, padre: DetPeticionCorredoresComponent){

  let fecha = new Date(res[0].fecha);

  const estado = res[0].par1.toString().trim(); 

  this.id = res[0].id ? res[0].id.toString() : "";
  this.fechaPet = this.formatearFecha(fecha);
  this.fecha = res[0].fecha;
  this.agente = res[0].agente.toString().trim().toUpperCase();
  this.nomCliente = res[0].asegurado.toString().trim().toUpperCase();
  this.telServ = res[0].telefono.toString().trim().toUpperCase();
  this.serRealizar = res[0].servicios.toString().trim().toUpperCase();
  this.observaciones = res[0].obser.toString().trim().toUpperCase();
  this.cia = res[0].cia.toString().trim().toUpperCase();
  this.matricula = res[0].matricula.toString().trim().toUpperCase();
  this.estado = estado;
  this.campana = res[0].campa.toString().trim().toUpperCase();
  this.taller = res[0].empresa.toString().trim().toUpperCase();
  padre.showCliente = res[0].par4 == "S";
  this.subdelega = res[0].agent_sub.toString().toUpperCase();
  padre.showEmail = estado === "3" || estado === "4";
  padre.showEmailbtn = estado === "3" || estado === "4";
  if (estado === "3") {
    padre.arrayAnula = padre.arrayAnulaAnulado;
    padre.tipoEmail = "3"; 
    padre.showAnulacion = true;
  }
  if (estado === "4") {
    padre.arrayAnula = padre.arrayAnulaRellamada;
    padre.showAnulacion = true;
  }
  padre.showAlert = ["114747", "121190", "121028", "190106", "190107"].includes(this.agente);
}


  public convertirHoja(padre: HojasCallCenterComponent) {
  if (this.taller == "106") {
    padre.mostrarArgumentario("Cuidado!", ["Asignación Algeciras.", "Agente asignado a taller Algeciras"], false, true, true);
  }
  if (this.taller > "400" && this.taller < "499") {
    padre.mostrarArgumentario("Cuidado!", ["Asignación Reparabrisas.", "Agente asignado a Reparabrisas"], false, true, true);
  }

  const esGestionCorredores = this.tipo.toString().trim() === "Gestión Corredores";

  if (!esGestionCorredores) {
    // Piloto + taller
    padre.onEntradaLlamadaSelected("100000059", this.taller.toString().padStart(3, '0'));
  } else {
    // Solo piloto
    padre.onEntradaLlamadaSelected("100000059");
  }

  padre.llamada.origen = "01";
  padre.llamada.tipo = "100";
  padre.auxCia = this.cia.toString().trim();
  padre.idcorredor = this.id.toString().trim();
  padre.asegurado.agente = this.agente.toString().trim();
  padre.asegurado.nombre = this.nomCliente.toString().trim();
  padre.asegurado.tel1 = this.telServ.toString().trim();
  padre.vehiculo.matricula = this.matricula.toString().trim();
  padre.asegurado.email = this.email.toString().trim();

  // Observaciones
  if (this.taller !== "") {
    padre.mensajeObser = "Taller - " + this.taller.toString().trim();

    if (esGestionCorredores && this.cia) {
      padre.mensajeObser += " | Compañía - " + this.cia.toString().trim();
    }

    padre.mensajeObser += " - " + this.observaciones.toString().trim();
  } else {
    padre.mensajeObser = this.observaciones.toString().trim();
  }

  if (this.serRealizar == "TRATAMIENTO DE OZONO") {
    padre.showTrabajos = true;
    padre.trabajoSeleccionado = "4";
  } else if (this.serRealizar == "TRATAMIENTO ANTILLUVIA") {
    padre.showTrabajos = true;
    padre.trabajoSeleccionado = "3";
  }

  this.fechaReal(padre, this.fecha);
  padre.idIncid = this.id.toString().trim();

  //
  //         Select Case txtagente.Text
  //             Case "300001"
  //                 BuscarCombos(HojasCallCenter.cmbpiloto, "MOTORGLASS")
  //             Case "300106"
  //                 BuscarCombos(HojasCallCenter.cmbpiloto, "FIRST STOP")
  //             Case "300108"
  //                 BuscarCombos(HojasCallCenter.cmbpiloto, "AUTIA RLS")
  //             Case "300002" To "300105"
  //                 BuscarCombos(HojasCallCenter.cmbpiloto, "RODI RLS")
  //         End Select
}







  public fechaReal(hojaprin: HojasCallCenterComponent, fecha:string){
    if(fecha && fecha.trim() != ""){
      let fechaPorDefecto = new Date(fecha);
      let mes = fechaPorDefecto.getMonth() + 1;
      let dia = fechaPorDefecto.getDate();
      let ano = fechaPorDefecto.getFullYear();
      hojaprin.asegurado.fecSin = `${ano}-${mes.toString().padStart(2, '0')}-${dia.toString().padStart(2, '0')}`;

    }
  }
  private formatearFecha(fecha: Date): string {
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // getMonth() es 0-index
    const año = fecha.getFullYear();
    const horas = fecha.getHours().toString().padStart(2, '0');
    const minutos = fecha.getMinutes().toString().padStart(2, '0');
    const segundos = fecha.getSeconds().toString().padStart(2, '0');

    return `${dia}/${mes}/${año}`;
  }

}